import { render, staticRenderFns } from "./existenceOfCriteries.vue?vue&type=template&id=f1b71512"
import script from "./existenceOfCriteries.vue?vue&type=script&lang=js"
export * from "./existenceOfCriteries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports